/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { BaseInputConfig } from '../../TaskInputs/types';

// TODO (RON-210): add formatters and masks if easy (see how this works in Borrower)
export const inputDefsMap: { [key: string]: BaseInputConfig } = {
  line1: {
    id: 'line1',
    type: 'text',
    required: true,
    label: 'Address Line 1',
  },
  line2: {
    id: 'line2',
    type: 'text',
    required: false,
    label: 'Address Line 2',
  },
  city: {
    id: 'city',
    type: 'text',
    required: true,
    label: 'City',
  },
  stateCode: {
    id: 'stateCode',
    type: 'state_code',
    required: true,
    label: 'State',
  },
  postalCode: {
    id: 'postalCode',
    type: 'postal_code',
    required: true,
    label: 'Zip Code',
  },
  county: {
    id: 'county',
    type: 'text',
    required: false,
    label: 'County',
  },
  // countryCode: {
  //   id: 'countryCode',
  //   type: 'country_code',
  //   required: true,
  //   label: 'Country'
  // }
};

export const addressFields = Object.keys(inputDefsMap);
